import { render, staticRenderFns } from "./TreatmentSectionAdvForm.vue?vue&type=template&id=20367466&scoped=true"
import script from "./TreatmentSectionAdvForm.vue?vue&type=script&lang=js"
export * from "./TreatmentSectionAdvForm.vue?vue&type=script&lang=js"
import style0 from "./TreatmentSectionAdvForm.vue?vue&type=style&index=0&id=20367466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20367466",
  null
  
)

export default component.exports